import { render, staticRenderFns } from "./waitPayResult.vue?vue&type=template&id=ee742aea&scoped=true&"
import script from "./waitPayResult.vue?vue&type=script&lang=js&"
export * from "./waitPayResult.vue?vue&type=script&lang=js&"
import style0 from "./waitPayResult.vue?vue&type=style&index=0&id=ee742aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee742aea",
  null
  
)

export default component.exports